import React from 'react'

export const Page1 = () => {
  return (
    <div id='page1'>
        <h1>DESIGN YOUR WORKFLOW
        </h1>
        <h2>Turn complex architecture into effortless automation.
        </h2>
        <p>Map, design, and optimize your web app structure with AI-powered insights. Instantly turn complex ideas into clear, interactive visual models that accelerate development and collaboration.</p>
    </div>
  )
}
